import { StyleSheet } from 'react-native';
import { spacing, ticketColors, ticketFonts } from '../theme/public-api';

/** Controles ticket: campos, search, hints. */
export const ticketControls = StyleSheet.create({
  field: {
    gap: 6,
    marginBottom: 12,
  },
  fieldLabel: {
    fontSize: 12,
    lineHeight: 12,
    fontWeight: '600',
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },
  input: {
    height: 40,
    paddingHorizontal: 12,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    fontSize: 14,
    fontWeight: '500',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  hint: {
    fontSize: 11,
    fontWeight: '500',
    color: ticketColors.ink3,
    lineHeight: 14,
    fontFamily: ticketFonts.sans,
  },
  warn: {
    fontSize: 11,
    fontWeight: '600',
    color: ticketColors.gold,
    lineHeight: 15,
    fontFamily: ticketFonts.sans,
  },
  searchOuter: {
    flex: 1,
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 10,
    backgroundColor: ticketColors.paper,
    paddingHorizontal: spacing.sm,
    minHeight: 40,
  },
  searchInput: {
    flex: 1,
    borderWidth: 0,
    backgroundColor: 'transparent',
    color: ticketColors.ink,
    minHeight: 40,
    fontSize: 14,
    fontWeight: '500',
    fontFamily: ticketFonts.sans,
  },
  searchClear: {
    // A11y: target ≥44px (antes ~30px: ícono 22 + padding xs).
    // El botón queda centrado dentro del recuadro de búsqueda (alignItems:center
    // en la fila) — el fondo es transparente, no cambia el layout visual salvo
    // que el recuadro crece a 44px donde no tenía altura fija.
    minWidth: 44,
    minHeight: 44,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: spacing.xs,
    paddingVertical: spacing.xs,
  },
  scanBtn: {
    width: 40,
    height: 40,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
    justifyContent: 'center',
  },
  scanLabel: {
    fontSize: 12,
    fontWeight: '700',
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },
  searchRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
  },
});
